<template>
    <div>
    <v-dialog v-model="showChangeLpn" width="650" persistent  >
      <v-row class="pa-0 ma-0 dialogXScrollHidden" >
        <v-col cols="12" sm="12" md="12" lg="12" class="pa-0 ma-0">
          <v-card class="pa-0 ma-0">
            <v-row class="pa-0 ma-0">
              <v-col cols="12" sm="12" md="12" lg="12" class="pa-0 ma-0">
            <v-card-title  dense class="subtitle-2 primary customwhite--text">
             {{dialogType=='LPN'? "Change LPN":"Verify Receipt"}}
              <v-spacer></v-spacer>
              <v-btn outlined class="pa-0" dense small title="Close" color="customwhite" @click="closeDialog()">
                <v-icon small>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <template v-if="dialogType=='LPN'">
                <v-form ref="changeLpn" lazy-validation @submit.prevent="submit">
              <v-row  class="px-5 py-0  my-1 pt-5">
                <v-col cols=" 12" sm="12" md="12" lg="5" class="py-0 my-0 px-1">
                  <v-text-field color="primarytext" v-model="lpn" label="LPN" outlined clearable dense
                    :rules="searchLPNRule"  persistent-placeholder
                    @keypress="lpnNumFormat($event, lpn)">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12" lg="2" class="py-0 my-0 px-0">
                  <v-btn class="btn-style" outlined elevation="1" color="primarytext" @click="getLPNNumber()"
                    :disabled="disableTargetLPN">
                    <v-icon>mdi-cart-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
            </template>
            <template v-else>
                <v-form ref="unitIdentifier" lazy-validation @submit.prevent="submit">
              <v-row  class="px-5 py-0  my-1 pt-5">
                <v-col cols=" 12" sm="12" md="12" lg="5" class="py-0 my-0 px-1">
                  <v-text-field color="primarytext" v-model="unitIndent" label="Unit Identifier" outlined clearable dense
                    :rules="required"  persistent-placeholder
                    >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions class="pt-3 pb-3 pr-4">
              <v-spacer></v-spacer>
              <!-- Add company page button -->
              <v-btn outlined  class="ma-1 mx-1 btn-style" color="primarytext" @click="onClickSubmit()">
                Submit
              </v-btn>
              <v-btn color="secondary" outlined dense class="ma-2 pl-2 ml-5 btn-style" @click="closeDialog()"
                elevation="1">
                Cancel
              </v-btn>
            </v-card-actions>
            </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-dialog>
    </div>
</template>
<script>
//import receiveService from "./receive-srvice";
import utility from "@/shared/utility";
import EncryptUtility from "../utility/js/encrypt-utility";
import commonApiService from "../common/js/common-api-service";
import receiveSrvice from "./js/receive-srvice";
export default {
    props: {
    showChangeLpn: Boolean,
    proj_key:Number,
    stage_bin_key:Number,
    dialogType:String,

    },
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      lpn:"",
      searchLPNRule: [
        (v) => (v || "").length <= 39 || "Max Length of 39 character",
        (v) => !!v || "Field is required",
        (value) =>
          /^[0-9]{1,3}(?:-[0-9]{3})*$/.test(value) ||
          "Enter a correct format: 000-000-000-000",
      ],
      
      required: [(v) => !!v || "Field is required"],
      unitIndent:"",
    }
  },
  async created() {
   
  },
  computed: {},

  mounted() {
     
  },
  methods: {
    lpnNumFormat(event, num) {
      this.lpn = utility.formatLPNNumber(event, num);
    },
    async getLPNNumber() {
      let lpnData = await commonApiService.getNextAvailableLPN(
        "get",
        this.userId
      );
      if (lpnData.message !== "NA") {
        this.lpn = lpnData[0]?.lpn;
      }
    },
    async onClickSubmit(){
        if(this.dialogType=='LPN'){
        let changeLpnObj={
            UserId: this.userId,
            bin_key: this.stage_bin_key,
            lpn: this.lpn,
            discrep: false,
            proj_key: this.proj_key
        }
        if(this.$refs.changeLpn?.validate()){
          let res=await receiveSrvice.postChangeLpn("post",changeLpnObj,true)
          if(JSON.parse(res).Status==200){
            this.closeDialog(true)
        }
        }
      }
      else{
        let verifyObj={
            UserId: this.userId,
            unit: this.unitIndent,
            proj_key: this.proj_key
        }
        if(this.$refs.unitIdentifier?.validate()){
          let res=await receiveSrvice.postQuickVerify("post",verifyObj,true)
          if(JSON.parse(res).Status==200){
            this.closeDialog(true)
        }
        }
      }


    },
    closeDialog(shouldUpdate = false){
        this.$refs.changeLpn?.resetValidation()
        this.$refs.unitIdentifier?.resetValidation()
        this.$emit("closeChangeLpnDialog", shouldUpdate ? this.lpn : null)
    }
  },
  
};

</script>